import { useQuery } from '@tanstack/react-query';
import { api } from './api';
import type { ClientStatsData } from '@/types/api';

export function useClientStats(clientId: number | undefined) {
  return useQuery({
    queryKey: clientId == null ? ['client-stats', null] : ['client-stats', clientId],
    enabled: clientId != null,
    queryFn: async (): Promise<ClientStatsData> => {
      const { data } = await api.get<ClientStatsData>(`/v1/clients/${clientId}/stats`);
      return data;
    },
  });
}
